<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FluxoCaixaCategoriasModule',
  }
</script>
